import { NodeProps } from '../../../../types.ts';
import CustomNode from './CustomNode.tsx';
import { useEdges, useReactFlow } from 'reactflow';
import { useEffect, useMemo } from 'react';
import { PythonFunctionConfiguration, WorkflowNode } from '../../../../api/model.ts';

const PythonFunctionNode = (props: NodeProps) => {
  const edges = useEdges();
  const reactFlow = useReactFlow();
  const edgesStr = JSON.stringify(edges.map((edge) => ({ ...edge, selected: false }))); // Prevent rerendering when edges are selected
  const configStr = JSON.stringify(props.data?.configuration);

  const configuration = useMemo(() => props.data?.configuration as PythonFunctionConfiguration, [configStr]);

  useEffect(() => {
    if (!configuration) {
      return;
    }
    const incomingEdges = edges.filter((edge) => edge.target === props.id);
    const predecessors = new Set(incomingEdges.map((edge) => edge.source));
    const newOrder = configuration.node_order?.filter((nodeId) => predecessors.has(nodeId)) ?? [];
    const newPredecessors: string[] = Array.from(predecessors).filter(
      (predecessorId) => !newOrder.includes(predecessorId),
    );

    newOrder.push(...newPredecessors);

    reactFlow.setNodes((nds) =>
      nds.map((node) => {
        if (node.id === props.id) {
          const nodeData = node.data as WorkflowNode;
          return {
            ...node,
            data: {
              ...nodeData,
              configuration: {
                ...nodeData.configuration,
                node_order: newOrder.length > 1 ? newOrder : null,
              } as PythonFunctionConfiguration,
            } as WorkflowNode,
          };
        }
        return node;
      }),
    );
  }, [edgesStr, configuration, props.id, reactFlow]);

  return <CustomNode {...props} />;
};

export default PythonFunctionNode;
